export const DO_FORGET_FAIL = 'DO_FORGET_FAIL';
export const DO_FORGET_ACTION = 'DO_FORGET_ACTION';
export const DO_FORGET_SUCCESS = 'DO_FORGET_SUCCESS';
export const COMMON_DELETE_API = 'COMMON_DELETE_API'; // No need to return response
